import ImageDocument from 'component/ImageDocument/ImageDocument'

import ArticleButton from './ArticleButton'
import { ArticleProps } from './article.types'

import { useMemo } from 'react'
import {
  ArticleContent,
  ArticleImage,
  ArticleImageDocument,
  ArticleTitle,
  ButtonsContainer,
  ContentContainer,
  MainContainer
} from './styles'
import isValidArticleButton from './utils/isValidArticleButton'

function Article({
  des,
  imageUrl,
  imageAlt,
  complement,
  position,
  buttons,
  textColor,
  titleColor,
  titleOnTop,
  ...divProps
}: ArticleProps) {
  const validButtons = useMemo(
    () => buttons?.filter(isValidArticleButton),
    [buttons]
  )

  return (
    <MainContainer
      noImage={!imageUrl}
      titleOnTop={!!titleOnTop}
      $reverse={position === 'right'}
      noTitle={!des}
      {...divProps}
    >
      {des && <ArticleTitle $color={titleColor}>{des}</ArticleTitle>}

      {typeof imageUrl === 'string' && (
        <ArticleImageDocument>
          <ArticleImage src={imageUrl} alt={imageAlt} />
        </ArticleImageDocument>
      )}

      {typeof imageUrl === 'object' && (
        <ArticleImageDocument>
          <ImageDocument documents={imageUrl} />
        </ArticleImageDocument>
      )}

      <ContentContainer noTitle={!des}>
        <ArticleContent $textColor={textColor}>{complement}</ArticleContent>
        {validButtons && validButtons.length > 0 && (
          <ButtonsContainer>
            {validButtons.map((button, index) => (
              <ArticleButton key={index} buttonConfig={button} />
            ))}
          </ButtonsContainer>
        )}
      </ContentContainer>
    </MainContainer>
  )
}

export default Article
